import React from 'react'
import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { appGlobal } from '../api/appGlobal';
import { mtUpdateCpv } from '../api/mtUpdateCpv';

import incode from './incode';

async function getConfirmar(navigate, rutaContinue, customerId) {

    if (customerId === localStorage.getItem("uuid")) {

        //actualizar cpv 

        const objIncode = {
            cpv: localStorage.getItem("sCpv")
        };

        const responseImg = await mtUpdateCpv(objIncode);

        navigate(rutaContinue);


    } else {

        navigate("/ValidacionFace");
    }
}

function FaceAutenticar({ rutaContinue, navigate, showError, showExitos }) {

    const containerRef = useRef();
    useEffect(() => {
        incode.renderLogin(containerRef.current, {
            onSuccess: r => {
                getConfirmar(navigate, rutaContinue, r.customerId);
            },
            onError: showError,
        });
    }, [showError, showExitos]);

    return <div ref={containerRef}></div>;
}

export default function FaceLoginPassaporte() {

    const navigate = useNavigate();
    const location = useLocation();

    const [session, setSession] = useState();
    const [step, setStep] = useState(1);
    const [error, setError] = useState(false);
    const [Token, setToken] = useState('');

    const rutaContinue = location.state.rutaContinue;
    const typeCredential = location.state.typeCredential;

    const flowId = appGlobal.configurationId;

    useEffect(() => {

        async function createSession() {
            const { token } = await incode.createSession("ALL", null, {
                configurationId: flowId,
            });
            setToken(token);
        }
        createSession();

    }, []);


    function goNext() {
        setStep(step + 1);
    }

    function showError() {
        setError(true);
    }

    function showExitos() {
        incode.getFinishStatus(flowId, { Token });
    }

    if (!Token) return "loading";
    if (error) return "Error!";
    return (
        <>
            <link
                rel="stylesheet"
                href="https://sdk-js.s3.amazonaws.com/sdk/styles-1.6.4.css"
            />
            <FaceAutenticar rutaContinue={rutaContinue} navigate={navigate} showError={showError} showExitos={showExitos} />
        </>
    );
}
